import { useGetAssetEnergySummary } from 'ClientPortal/src/api/Queries/value-overview'
import { useAssetPageLayout } from 'ClientPortal/src/pages/Assets/AssetDetails/AssetPageLayout/AssetPageLayout.data'

export function useAssetKeyValues() {
    const {
        asset,
        assetId,
        valuations,
        latestFinalizedValuationOrDraft,
        latestOrder,
        isAssetLayoutPending: isAssetKeyValuesPending,
    } = useAssetPageLayout()

    const { assetEnergySummary, isAssetEnergySummaryLoading } = useGetAssetEnergySummary({
        assetId,
    })

    return {
        asset,
        isAssetKeyValuesPending,
        valuations,
        latestFinalizedValuationOrDraft,
        latestOrder,
        assetEnergySummary,
        isAssetEnergySummaryLoading,
    }
}
